import { Serializers, SerializerValue } from "@megaron/serializers";

export const blikCheckStatuses = [
  "pending",

  "outstanding", // 0
  "cashed", // 1
  "cancelled", // 2
  "expired", // 3
  "blocked", // 4
  "bankRejected", // 5
  "pspRejected", // 6
  "processing", // 7
] as const;
export type BlikCheckStatus = (typeof blikCheckStatuses)[number];

export const blikCheckFiltersSerializer = Serializers.object({
  page: Serializers.integer,
  status: Serializers.stringOneOf(...blikCheckStatuses)
    .array()
    .asJsonString(),
  searchTerm: Serializers.string,
}).partial();

export type BlikCheckFilters = SerializerValue<typeof blikCheckFiltersSerializer>;

export const cashRewardsAccountSortOrders = ["asc", "desc"] as const;
export type CashRewardsAccountSortOrder = (typeof cashRewardsAccountSortOrders)[number];

export const cashRewardsAccountFiltersSerializer = Serializers.object({
  page: Serializers.integer,
  excludeZeroBalance: Serializers.boolean,
  sortByBalance: Serializers.stringOneOf(...cashRewardsAccountSortOrders),
}).partial();

export type CashRewardsAccountFilters = SerializerValue<typeof cashRewardsAccountFiltersSerializer>;
